
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.2 28.54a.926.926 0 001.6 0l8.033-12.81a1.118 1.118 0 00.032-1.12l-1.7-3.1a.953.953 0 00-.832-.51H23.666a.954.954 0 00-.83.512l-1.7 3.1a1.117 1.117 0 00.031 1.12L29.2 28.54zm-.22-14.404h7.284l.535.973-.7 1.118H28.98a1.046 1.046 0 010-2.091zm-5.244 0H24.9a1.046 1.046 0 010 2.09h-1l-.7-1.117.536-.973z","fill":"#fff"}})])
          )
        }
      }
    